import { useState } from 'react';
import Button from '@components/Button';
import ClientForm from '../../partials/form/ClientForm';
import ModalDerived from './partials/ModalDerived';

const ContentStep1 = (props) => {
  const [open, setOpen] = useState(false)
  const [emailValidate, setEmailValidate] = useState(false)

  const idDisabled = () => {
    const client = props.client
    if (client.email && emailValidate && client.document && client.name && client.phone?.length > 14 && !client.derived) {
      if (props.type === "cart" || (props.type === "transfer" && (props.client.addresses?.length))) {
        return false
      }
      if ((props.type === "tour" || props.type === "combo") && client.addresses.length && (client?.addresses[0]?.hotel || client?.addresses[1]?.hotel) && (client?.addresses[0]?.hotel_address || client?.addresses[1]?.hotel_address)) {
        return false
      }
    } else if (client.partnerEmail && client.email && client.phone?.length > 14 && client.addresses.length) {
      return false
    }
    return true
  }

  const openModal = () => {
    const client = props.client
    if (client.partnerEmail === client.email) {
      setOpen(true)
    } else {
      props.changeStep(2)
    }
  }

  const isDerived = (confirm) => {
    if (confirm) {
      props.changeClient({
        target: {
          name: 'derived',
          value: confirm
        }
      })
      props.changeStep(2)
    } else {
      const data = {
        derived: confirm,
        email: ''
      }
      props.notDerived(data)
    }
  }
  return <>
    <div className="mt-4 font-poppins" style={{ borderRadius: '10px', backgroundColor: '#172B4D', color: '#e8f0fb' }}>
      <ClientForm
        client={props.client}
        reserve={props.reserve}
        changeReserve={props.changeReserve}
        clientEmail={props.reservationData?.cart[0]?.customer_email}
        regionsTravel={props.regionsTravel}
        changeClientByEmail={props.changeClientByEmail}
        changeClientByPartner={props.changeClientByPartner}
        changeClient={props.changeClient}
        changeClientAddress={props.changeClientAddress}
        changeObservations={props.changeObservations}
        onlyLetterAndNumber={props.onlyLetterAndNumber}
        changeClientCheckbox={props.changeClientCheckbox}
        changeSetEmail={setEmailValidate}
      />
      <ModalDerived
        open={open}
        close={() => setOpen(false)}
        isDerived={isDerived}
      />
    </div>
    <div className="flex space-x-5 justify-end mb-4">
      <Button
        textcolor="#e8f0fb"
        padding="6px 15px"
        width="100px"
        variant="outlined"
        onClick={props.backPage}
        bgColor="transparent"
      >
        Voltar
      </Button>
      <Button
        disabled={idDisabled()}
        textcolor="#fff"
        padding="6px 15px"
        width="260px"
        onClick={() => openModal()}
        customcolor={props.theme.color}
      >
        Continuar para pagamento
      </Button>
    </div>
  </>
}

export default ContentStep1;